import * as go from 'gojs';
import { IS_SIDEBAR_TYPE_PROP } from '../../common/config/common-prop-names';
import { setTemporaryPortStroke, restoreTemporaryPortStroke } from './linking-utils';

export const linkOverrideDraggingTool = (diagram: go.Diagram) => {
  const draggingTool = diagram.toolManager.draggingTool;

  overrideDragging(draggingTool);
};

const overrideDragging = (tool: go.DraggingTool) => {
  const doActivateBase = tool.doActivate.bind(tool);
  const doDeactivateBase = tool.doDeactivate.bind(tool);
  const dragsLinkBase = tool.dragsLink;
  const linkingUnconnectedValidBase = tool.diagram.toolManager.linkingTool.isUnconnectedLinkValid;
  const relinkingUnconnectedValidBase = tool.diagram.toolManager.relinkingTool.isUnconnectedLinkValid;

  tool.doActivate = () => {
    const currentPart = tool.diagram.findPartAt(tool.diagram.firstInput.documentPoint, false);
    if (currentPart instanceof go.Link && !!currentPart.data[IS_SIDEBAR_TYPE_PROP]) {
      tool.dragsLink = true;
      tool.diagram.toolManager.linkingTool.isUnconnectedLinkValid = true;
      tool.diagram.toolManager.relinkingTool.isUnconnectedLinkValid = true;
      tool.diagram.toolManager.relinkingTool.originalLink = currentPart;
      setTemporaryPortStroke(tool.diagram.toolManager.relinkingTool);
    }
    doActivateBase();
  };

  tool.doDeactivate = () => {
    doDeactivateBase();
    restoreTemporaryPortStroke(tool.diagram.toolManager.relinkingTool);
    tool.dragsLink = dragsLinkBase;
    tool.diagram.toolManager.linkingTool.isUnconnectedLinkValid = linkingUnconnectedValidBase;
    tool.diagram.toolManager.relinkingTool.isUnconnectedLinkValid = relinkingUnconnectedValidBase;
  };
};
